// extracted by mini-css-extract-plugin
module.exports = {"merit":"MeritSection_merit__eI3w0","number":"MeritSection_number__Br3a1"};